import React from "react";
import { RiFacebookFill } from "react-icons/ri";
import { AiOutlineInstagram } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { ImLinkedin2 } from "react-icons/im";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useResultContext } from "../../../src/app";

function Footer1() {
  const { setactive } = useResultContext();
  function scrollToTestDiv() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  return (
    <div>
      <div className="slm">
        <div className="flex wrapper wrappertablet wrapperphone phonex2:flex-col  phonex2:text-center phonex2:justify-center justify-between z-40 text-white bg-gray-900   py-[190px] ">
          <div className="flex z-20">
            <div className="space-y-6 phonex2:m-auto">
              <a href="/">
                <div className="w-fit phonex2:m-auto relative pointer-events-none">
                  <div className="font-font text-center text-white text-[27px] md:text-[34px] leading-3">
                    Citronella
                  </div>
                  <div className="absolute top-[-17px] md:top-[-25px] left-[-20%] -rotate-[25deg]">
                    <img
                      className="h-4 md:h-6"
                      src="/images/logo.png"
                      alt="logo"
                    />
                  </div>
                </div>
              </a>{" "}
              <p className=" max-w-[300px] phone:pr-20 phonex2:p-0 phone:max-w-[600px] text-gray-300  leading-[27px] font-font demitablet:text-[14px]  font-thin [30px] text-sm">
                Receive A Free 15 ML Bottle Of Citronella When You Place A 125
                PV Or More Loyalty Order By April 15 While Supplies Last!
              </p>
              <div className="flex items-center phonex2:justify-center space-x-8  ">
                <div className="relative flex ">
                  <div className="bg-primary-200 absolute rounded-full h-10 animate-ping w-10 z-0 p-1 items-center " />
                  <div className="bg-primary-100 z-10 relative rounded-full h-6 w-6 p-[19px] ">
                    <RiFacebookFill className="w-[20px] h-[20px] absolute  transform -translate-x-1/2 -translate-y-1/2 top-1/2 left1/2" />
                  </div>
                </div>
                <div className="relative flex ">
                  <div className="bg-primary-200 absolute rounded-full h-10 animate-ping w-10 z-0 p-1 items-center " />
                  <div className="bg-primary-100 z-10 relative rounded-full h-6 w-6 p-[19px] ">
                    <AiOutlineInstagram className="w-[20px] h-[20px] absolute  transform -translate-x-1/2 -translate-y-1/2 top-1/2 left1/2" />
                  </div>
                </div>
                <div className="relative flex ">
                  <div className="bg-primary-200 absolute rounded-full h-10 animate-ping w-10 z-0 p-1 items-center " />
                  <div className="bg-primary-100 z-10 relative rounded-full h-6 w-6 p-[19px] ">
                    <AiOutlineTwitter className="w-[20px] h-[20px] absolute  transform -translate-x-1/2 -translate-y-1/2 top-1/2 left1/2" />
                  </div>
                </div>
                <div className="relative flex ">
                  <div className="bg-primary-200 absolute rounded-full h-10 animate-ping w-10 z-0 p-1 items-center " />
                  <div className="bg-primary-100 z-10 relative rounded-full h-6 w-6 p-[19px] ">
                    <ImLinkedin2 className="w-[20px] h-[20px] absolute  transform -translate-x-1/2 -translate-y-1/2 top-1/2 left1/2" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex phonex2:flex-col phonex2:space-y-10 z-20 phonex2:space-x-0 space-x-[130px] tablet:space-x-[90px] demitablet:space-x-14 font-font font-thin phonex2:mt-6">
            <div className="flex flex-col  space-y-[30px]">
              <span className="font-bold text-white phonex2:mt-10 phonex2:w-full rounded-md phonex2:p-4 phonex2:bg-primary-100">
                Company
              </span>

              <Link
                onClick={() => {
                  setactive(1);
                  scrollToTestDiv();
                }}
                to="/products"
              >
                <a
                  href="/#"
                  className="text-gray-300 hover:text-gray-100 cursor-pointer"
                >
                  Products
                </a>
              </Link>
              <Link
                onClick={() => {
                  setactive(2);
                  scrollToTestDiv();
                }}
                to="/about-us"
              >
                <a
                  href="/#"
                  className="text-gray-300 hover:text-gray-100 cursor-pointer"
                >
                  About Us
                </a>
              </Link>
              <Link
                onClick={() => {
                  setactive(3);
                  scrollToTestDiv();
                }}
                to="/contact"
              >
                <a
                  href="/#"
                  className="text-gray-300 hover:text-gray-100 cursor-pointer"
                >
                  Contact
                </a>
              </Link>
            </div>
            <div className="flex flex-col   space-y-[30px]">
              <span className="font-bold text-white phonex2:w-full rounded-md phonex2:p-4 phonex2:bg-primary-100">
                Contact Us
              </span>
              <div className="flex items-center phonex2:justify-center  text-gray-300 hover:text-gray-100 space-x-4 capitalize">
                <BsFillTelephoneFill className="h-4 w-4" />
                <span>+(65) 6653 4123</span>
              </div>
              <div className="flex items-center phonex2:justify-center  text-gray-300 hover:text-gray-100 space-x-4">
                <MdEmail className="h-4 w-4" />
                <span>Hello@gmail.com</span>
              </div>
              <div className="flex items-center text-gray-300 phonex2:justify-center  hover:text-gray-100  space-x-4">
                <FaMapMarkerAlt className="max-h-6 w-6" />
                <span className="demitablet:max-w-[200px]">
                  one neil road #02-02, singapore 081231
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex z-20 justify-center border-t-[1px] border-gray-400 uppercase bg-gray-900 text-white">
          <h1 className="font-thin z-20 demitablet:text-[14px]  my-[24px] text-gray-400">
            copyright © {new Date().getFullYear()} osama D
          </h1>
        </div>
      </div>
    </div>
  );
}

export default Footer1;
